import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import useLocalStorage from 'src/shared/hooks/useLocalStorage';
import * as Yup from "yup";
import {
    TableContainer, Table, TableBody, Grid, DialogContent, TableRow, TableCell, Paper, DialogActions,
    CardHeader, DialogTitle,
    Dialog, Stack, Box,
    Button,
    InputAdornment
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";

// import AuthService from 'src/core/access-control/AuthService';
import Iconify from "src/shared/components/Iconify";
import call from 'src/core/services/http';
import { CustomCell, CustomRow } from 'src/shared/TableComponents/TableStyles';
import ListHead from 'src/shared/TableComponents/ListHead';
import { toast } from "react-toastify";
import SpinnerLoader from "../../../shared/plugin/loader/SpinnerLoader";
import { LoadingButton } from '@mui/lab';
import { CustomDialog, CustomDialogTitle } from 'src/shared/sharebles/items';
import Page from "../../../shared/components/Page";
import { FormProvider, RHFTextField, RHFSelect } from "../../../shared/components/hook-form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import BillNumberConstants from "src/shared/reducers/BillNumber/BillNumberConstants";
import Title from "src/shared/Text/Title";
import Label from "src/shared/components/Label";
import { fDateDMY, fDateTime } from 'src/shared/utils/formatTime';

const TABLE_HEAD = [
    { id: 'description', label: "Trigger Account ", alignLeft: true },
    { id: 'split_beneficiary', label: "Split Beneficiaries ", alignLeft: true },
    { id: 'total_share_value', label: "Total Share Value", alignLeft: true },
    { id: 'minimum_threshold', label: " Minimum Threshold", alignLeft: true },
    { id: 'split_value_type', label: "Split Value Type", alignLeft: true },
    { id: 'total_split_beneficiaries', label: "Total Split Beneficiaries", alignLeft: true },
    { id: 'status', label: "status", alignLeft: true },
    { id: 'created_at', label: "Date Created", alignLeft: true },
];

const ConfigurationsTable = () => {
    const [shop] = useLocalStorage('shop-details');
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [selected, setSelected] = useState({});
    const [open, setOpen] = useState(false);
    const [row, setrow] = useState({})
    const [isNotFound, setIsNotFound] = useState(false);
    const [payerFields, setPayerFields] = useState([]);
    const [state, setState] = useState({
        account_number: "",
        account: { account_number: "", account_name: "" }
    });

    const [configData, setConfigData] = useState({});
    const [recordCreated, setRecordCreated] = useState(false); 
    
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = Object.keys(data).map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected({});
    };

    const getConfigurations = async () => {
        try {
            setIsLoading(true);
            const response = await call('get', `/merchants/split-account-configuration/?account_number=${shop.account_number}`);
            if (response.data.status) {
                setConfigData(response.data.splits_accounts);
                
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getConfigurations();
    }, []);

    const handleAddPayerClick = () => {
        const newPayer = { account_number: "", share_value: "" };
        setPayerFields([...payerFields, newPayer]);
    };

    const [valueType, setValueType] = useState("");

    const handleSplitValueChange = (e) => {
        setValueType(e.target.value)
    }

    const SplitBillSchema = Yup.object().shape({
        beneficiaries: Yup.array().of(
            Yup.object().shape({
                beneficiary_account_number: Yup.string().required('Fill in the Account Number'),
                share_value: Yup.string().required('Fill in the Share Amount'),
            })
        ),
    });

    const defaultValues = {
        account_number: shop.account_number,
        split_value_type: "",
        beneficiary_account_number: "",
        share_value: "",
    };

    const methods = useForm({
        resolver: yupResolver(SplitBillSchema),
        defaultValues,
    });

    const { handleSubmit, setValue, formState: { isSubmitting }, watch } = methods;

    const onSubmit = async (data) => {
        const { beneficiaries } = data;

        // const totalPercentage = beneficiaries.reduce(
        //     (total, payer) => total + parseFloat(payer.share_value || 0),
        //     0
        // );

        // if (totalPercentage > 100) {
        //     toast.error("Total share percentage cannot exceed 100 Percent.");
        //     return;
        // }

        if (valueType !== "VALUE") {
            const totalPercentage = beneficiaries.reduce(
                (total, beneficiary) => total + parseFloat(beneficiary.share_value || 0),
                0
            );
    
            if (totalPercentage > 100) {
                toast.error("Total share percentage cannot exceed 100 Percent.");
                return;
            }
        }
        beneficiaries.forEach(beneficiary => {
            beneficiary.share_value = parseFloat(beneficiary.share_value);
        });

      
    

        const payload = {
            account_number: shop.account_number,
            split_value_type: valueType,
            beneficiaries: watch("beneficiaries"),
        };

        try {
            const response = await call("post", `/merchants/split-account-configuration/`, payload);

            if (response.data.status) {
                toast.success(response.data.message);
                methods.reset();
                setValueType("");
                setRecordCreated(true);
                setOpen(false)
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const searchAccount = async (accountNumber, index) => {
        try {
            const response = await call('post', BillNumberConstants.ACCOUNT_SEARCH, { account_number: accountNumber });

            if (response.data.status) {
                const { account_name } = response.data.account;

                setState((prevState) => ({
                    ...prevState,
                    account: { ...prevState.account, [index]: { account_number: accountNumber, account_name } },
                }));
                setValue(`beneficiaries[${index}].beneficiary_account_number`, accountNumber);

            } else {
                setState((prevState) => ({
                    ...prevState,
                    account: { ...prevState.account, [index]: { account_number: accountNumber, account_name: '' } },
                }));
            }
        } catch (error) {
            console.error(error);
        }
    };

    const splitValues = [
        "PERCENTAGE",
        "VALUE"
    ];

    const renderedOptions = splitValues.map((purposeItem, index) => {
        const id = index;
        return (
            <option key={id} value={purposeItem}>
                {purposeItem}
            </option>
        );
    });

    return (
        <Page title='Split Configurations Table'>
            <Dialog
                fullWidth
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
            >
                <DialogTitle>Create Split Configuration</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} justifyContent="center" >
                        <Grid item xs={12} md={6} lg={6}>
                            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                <Stack spacing={2} mt={2}>
                                    <RHFSelect
                                        fullWidth
                                        name="split_value_type"
                                        size={'medium'}
                                        value={valueType}
                                        onChange={handleSplitValueChange}
                                    >
                                        <option>Select Split Value Type * </option>
                                        {renderedOptions}
                                    </RHFSelect>
                                    {watch("description") && (
                                        <input type="hidden" {...methods.register("name")} value={watch("description")} />
                                    )}
                                    <Box sx={{ m: 1 }}>
                                        <Box sx={{ display: 'flex', justifyContent: "space-between" }} >
                                            <Title text="" sx={{ color: 'black' }} />
                                            <Stack spacing={2} direction="row">
                                                <Button variant="contained" onClick={handleAddPayerClick} color='primary' startIcon={<Iconify icon="eva:plus-fill" />}>Add A Beneficiary</Button>
                                            </Stack>
                                        </Box>
                                    </Box>
                                    {payerFields.map((payer, index) => (
                                        <Grid container spacing={2} key={index}>
                                            <Grid item sm={12} xs={12} lg={6} md={6}>
                                                <RHFTextField
                                                    size={'medium'}
                                                    fullWidth
                                                    name={`beneficiaries[${index}].beneficiary_account_number`}
                                                    label='Beneficiary Account Number'
                                                    onBlur={(e) => searchAccount(e.target.value, index)}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <span style={{ color: 'green' }}>{state.account[index] ? state.account[index].account_name : ''}</span>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item sm={12} xs={12} lg={6} md={6}>
                                                <RHFTextField
                                                    size={'medium'}
                                                    fullWidth
                                                    name={`beneficiaries[${index}].share_value`}
                                                    label='Share Value'
                                                />
                                            </Grid>
                                        </Grid>
                                    ))}
                                    <Stack direction={{ sm: 'column', md: 'row' }} spacing={5} alignContent='space-between'>
                                        <LoadingButton fullWidth size="medium" onClick={() => setOpen(!open)} variant='outlined' color='error'>
                                            Cancel
                                        </LoadingButton>
                                        <LoadingButton loading={isSubmitting} fullWidth size="medium" type="submit" variant='contained' color='primary'>
                                            Submit
                                        </LoadingButton>
                                    </Stack>
                                </Stack>
                            </FormProvider>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            <Card>
            <CardHeader action={!recordCreated && !Object.keys(configData).length && <Button variant='contained' size='small' onClick={() => setOpen(!open)}>Create Split Configuration</Button>} />
                <CardContent>
                    {isLoading ? (
                        <Grid container sx={{ justifyContent: 'center' }}><SpinnerLoader /></Grid>
                    ) : (
                        <>
                            <TableContainer >
                                <Table>
                                    <ListHead
                                        order={order}
                                        orderBy={orderBy}
                                        headLabel={TABLE_HEAD}
                                        numSelected={Object.keys(selected).length}
                                        onRequestSort={handleRequestSort}
                                        onSelectAllClick={handleSelectAllClick} />
                                    {isNotFound ? (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                                                    <Paper
                                                        sx={{
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <Typography variant="h6" paragraph>
                                                            Not found
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            No results found for <strong>{shop.account_number}</strong>
                                                        </Typography>
                                                    </Paper>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            <CustomRow hover >
                                                <TableCell>{configData?.trigger_savings_account?.description}</TableCell>
                                                {configData?.split_beneficiary?.map((beneficiary, index) => (
                                                    <CustomRow key={index} hover>
                                                        <TableCell>{beneficiary?.beneficiary_account?.account_number}-{beneficiary?.beneficiary_account?.description}</TableCell>
                                                        <TableCell>Value-{beneficiary?.share_value}</TableCell>
                                                    </CustomRow>
                                                ))}
                                                <TableCell>{configData?.total_share_value}</TableCell>
                                                <TableCell>{configData?.minimum_threshold}</TableCell>
                                                <TableCell>{configData?.split_value_type}</TableCell>
                                                <TableCell>{configData?.total_split_beneficiaries}</TableCell>
                                                <TableCell>{configData?.status === 1 ? <Label color="info" >Active</Label> : "" }</TableCell>
                                                <TableCell>{fDateTime(configData?.created_at)}</TableCell>
                                            </CustomRow>
                                            {/* ))} */}
                                        </TableBody>
                                    )}
                                </Table>
                            </TableContainer>
                        </>
                    )}

                </CardContent>
            </Card>
        </Page>
    )
}

export default ConfigurationsTable;
